import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '~/store';
import TableModal from '../../TableModal';

interface PropsModal {
  row?: any;
  action: string;
}

const Modal: React.FC<PropsModal> = ({ row, action }) => {
  const historico = useSelector<ApplicationState, any>(
    state => state.ExibirHistoricoDeManutencaoDasAtividades,
  );

  const [exibir, setExibir] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setExibir(false);
    }, 50);
    setTimeout(() => {
      setExibir(true);
    }, 100);
  }, [row, historico.cleanModal]);

  const data = useMemo(() => {
    return historico.detalhe;
  }, [historico.detalhe]);

  return (
    <div
      className="modal-lgpd modal fade modal-lgpd-inf-historico"
      id="ModalLabelExibirHistoricoDeManutencaoDasAtividades"
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-lgpd" role="document">
        <div className="modal-content">
          <div className="modal-header" style={{ textAlign: 'center' }}>
            <h5
              className="modal-title"
              id="exampleModalLabel"
              style={{ fontSize: '1.8rem', fontWeight: 'bold' }}
            >
              Detalhe da manutenção
            </h5>
            <button
              type="button"
              className="close button-close-modal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <TableModal data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
